import React, { useMemo } from "react";
import { View } from "react-native";
import { NextBestActionType } from "../../../../../../projection/nextBestActionDefinition/nextBestActionDefinition";
import { NextBestActionItem } from "../../../../components/nextBestActionItem/NextBestActionItem";
import { DOMAIN } from "../../../../i18n/i18n";
import { NextBestActionTitle } from "../nextBestActionTitle/NextBestActionTitle";
import { style as nextBestActionHostDefaultStyle } from "./NextBestActionHostDefault.style";

const NextBestActionHostDefault: NextBestActionItem<NextBestActionType.HOST_DEFAULT> = ({
  action: { translationKey },
  segment,
  children,
}) => {
  const style = useMemo(() => nextBestActionHostDefaultStyle(), []);

  return (
    <View style={style.container} testID="next-best-action-host-default">
      {translationKey && (
        <View style={style.titleContainer}>
          <NextBestActionTitle domain={DOMAIN} segment={segment} translationKey={translationKey} />
        </View>
      )}

      {children}
    </View>
  );
};

export { NextBestActionHostDefault };
